import { create } from 'zustand';

import type { BoardElementId } from './boardSelectionStore';

export interface BoardElementRect {
  height: number;
  width: number;
  x: number;
  y: number;
}

interface BoardElementRectState {
  rects: Record<string, BoardElementRect>;
}

interface BoardElementRectActions {
  removeElementRect: (elementId: BoardElementId) => void;
  resetElementRects: () => void;
  setElementRect: (elementId: BoardElementId, rect: BoardElementRect) => void;
}

export type BoardElementRectStore = BoardElementRectState & BoardElementRectActions;

export const useBoardElementRectStore = create<BoardElementRectStore>((set) => ({
  rects: {},
  removeElementRect: (elementId) =>
    set((state) => {
      const { [elementId]: _removed, ...rects } = state.rects;

      return { rects };
    }),
  resetElementRects: () => set({ rects: {} }),
  setElementRect: (elementId, rect) =>
    set((state) => {
      const currentRect = state.rects[elementId];

      if (
        currentRect &&
        currentRect.x === rect.x &&
        currentRect.y === rect.y &&
        currentRect.width === rect.width &&
        currentRect.height === rect.height
      ) {
        return state;
      }

      return {
        rects: {
          ...state.rects,
          [elementId]: rect,
        },
      };
    }),
}));
